import React from "react";

const FeaturedCaseStudies = () => {

    const projects = [
        {
            number: "01",
            category: "FINTECH",
            title: "FinFlow Platform",
            description:
                "Built a modern financial platform enabling secure transactions, analytics dashboards and seamless payment experiences for thousands of users.",
            result: "+320% Growth",
            tech: ["React", "Node.js", "AWS"]
        },
        {
            number: "02",
            category: "HEALTHCARE",
            title: "MediCare Mobile App",
            description:
                "Developed a healthcare ecosystem connecting patients, doctors and clinics through real-time scheduling and telemedicine services.",
            result: "120K+ Users",
            tech: ["Flutter", "Firebase", "Laravel"]
        },
        {
            number: "03",
            category: "E-COMMERCE",
            title: "ShopVerse",
            description:
                "Created a high-performance e-commerce platform with personalized shopping experiences and advanced conversion optimization.",
            result: "+280% Revenue",
            tech: ["Next.js", "Stripe", "MongoDB"]
        }
    ];

    return (
        <>
            <section className="fcs-section">

                <div className="fcs-container">

                    <div className="fcs-heading">

                        <span>FEATURED WORK</span>

                        <h2>
                            Success Stories
                            <br />
                            That Drive Results
                        </h2>

                    </div>

                    {projects.map((project, index) => (

                        <div
                            key={index}
                            className={`fcs-row ${index % 2 !== 0
                                    ? "reverse"
                                    : ""
                                }`}
                        >

                            {/* IMAGE */}
                            <div className="fcs-image">

                                <div className="fcs-image-inner">

                                    <div className="fcs-number">
                                        {project.number}
                                    </div>

                                    <div className="fcs-result">
                                        {project.result}
                                    </div>

                                </div>

                            </div>

                            {/* CONTENT */}
                            <div className="fcs-content">

                                <span className="fcs-category">
                                    {project.category}
                                </span>

                                <h3>
                                    {project.title}
                                </h3>

                                <p>
                                    {project.description}
                                </p>

                                <div className="fcs-tech">

                                    {project.tech.map((tech, i) => (
                                        <span key={i}>
                                            {tech}
                                        </span>
                                    ))}

                                </div>

                                <a href="#">
                                    View Case Study →
                                </a>

                            </div>

                        </div>

                    ))}

                </div>

                <style>{`

                .fcs-section{
                    padding:150px 24px;
                    background:#fff;
                }

                .fcs-container{
                    max-width:1300px;
                    margin:auto;
                }

                .fcs-heading{
                    text-align:center;
                    margin-bottom:100px;
                }

                .fcs-heading span{
                    display:inline-block;
                    padding:12px 22px;
                    border-radius:999px;
                    background:rgba(232,33,42,.08);
                    color:#E8212A;
                    font-size:13px;
                    font-weight:700;
                    letter-spacing:1px;
                    margin-bottom:24px;
                }

                .fcs-heading h2{
                    font-size:clamp(35px,7vw,58px);
                    line-height:.95;
                    color:#111;
                        text-align: center;
                    font-family:'Syne',sans-serif;
                }

                .fcs-row{
                    display:grid;
                    grid-template-columns:1fr 1fr;
                    gap:70px;
                    align-items:center;
                    margin-bottom:120px;
                }

                .fcs-row.reverse .fcs-image{
                    order:2;
                }

                .fcs-row.reverse .fcs-content{
                    order:1;
                }

                .fcs-image{
                    height:550px;
                }

                .fcs-image-inner{
                    width:100%;
                    height:100%;
                    border-radius:40px;
                    position:relative;
                    overflow:hidden;

                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );

                    box-shadow:
                    0 40px 100px rgba(232,33,42,.18);

                    transition:.5s;
                }

                .fcs-image-inner:hover{
                    transform:scale(1.03);
                }

                .fcs-image-inner::before{
                    content:"";
                    position:absolute;
                    width:500px;
                    height:500px;
                    border-radius:50%;
                    background:
                    rgba(255,255,255,.08);
                    right:-200px;
                    top:-150px;
                }

                .fcs-image-inner::after{
                    content:"";
                    position:absolute;
                    width:280px;
                    height:280px;
                    border-radius:50%;
                    border:1px solid rgba(255,255,255,.15);
                    bottom:-100px;
                    left:-100px;
                }

                .fcs-number{
                    position:absolute;
                    left:40px;
                    top:40px;
                    font-size:110px;
                    color:rgba(255,255,255,.18);
                    font-weight:800;
                    font-family:'Syne',sans-serif;
                }

                .fcs-result{
                    position:absolute;
                    bottom:40px;
                    left:40px;

                    padding:18px 28px;
                    border-radius:18px;

                    background:
                    rgba(255,255,255,.15);

                    backdrop-filter:blur(20px);

                    color:#fff;
                    font-size:24px;
                    font-weight:700;
                }

                .fcs-category{
                    color:#E8212A;
                    font-size:13px;
                    letter-spacing:2px;
                    font-weight:700;
                    display:block;
                    margin-bottom:20px;
                }

                .fcs-content h3{
                    font-size:40px;
                    line-height:1;
                    color:#111;
                    margin-bottom:25px;
                    font-family:'Syne',sans-serif;
                }

                .fcs-content p{
                    color:#666;
                    font-size:18px;
                    line-height:1.9;
                    margin-bottom:30px;
                }

                .fcs-tech{
                    display:flex;
                    gap:12px;
                    flex-wrap:wrap;
                    margin-bottom:35px;
                }

                .fcs-tech span{
                    padding:10px 18px;
                    border-radius:999px;
                    background:#f5f5f5;
                    color:#111;
                    font-size:14px;
                    font-weight:600;
                }

                .fcs-content a{
                    display:inline-flex;
                    align-items:center;
                    gap:10px;

                    padding:16px 28px;
                    border-radius:16px;
                    text-decoration:none;

                    color:#fff;
                    font-weight:700;

                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );

                    box-shadow:
                    0 20px 50px rgba(232,33,42,.22);
                }

                @media(max-width:991px){

                    .fcs-row{
                        grid-template-columns:1fr;
                        gap:40px;
                    }

                    .fcs-row.reverse .fcs-image,
                    .fcs-row.reverse .fcs-content{
                        order:unset;
                    }

                    .fcs-image{
                        height:420px;
                    }

                }

                @media(max-width:768px){

                    .fcs-section{
                        padding:100px 18px;
                    }

                    .fcs-heading h2{
                        letter-spacing:-2px;
                    }

                    .fcs-content h3{
                        font-size:42px;
                    }

                    .fcs-number{
                        font-size:80px;
                    }

                    .fcs-result{
                        font-size:18px;
                    }

                }

            `}</style>

            </section>
        </>
    );
};

export default FeaturedCaseStudies;